import { Component } from '@opten/gin-tonic/helpers/compiler';

@Component({ className: 'js-partner-overlay' })
export class PartnerOverlayComponent {
	private overlay: HTMLElement;
	private content?: HTMLElement | null;
	private dismissBtn?: HTMLButtonElement | null;

	constructor(element: HTMLElement) {
		this.overlay = element;
		this.content = document.querySelector<HTMLElement>(
			'.js-partner-overlay-content'
		);
		this.dismissBtn = this.overlay.querySelector<HTMLButtonElement>(
			'.js-partner-overlay-dismiss'
		);
		this.init();
	}

	private init() {
		// Ensure content is hidden initially if overlay is present
		if (this.overlay && this.content) {
			this.content.classList.add('is-hidden-by-overlay');
		}

		this.dismissBtn?.addEventListener('click', (ev) => {
			ev.preventDefault();
			this.fadeOut();
		});
	}

	private fadeOut() {
		this.overlay.classList.add('is-fading');
		const duration = 500; // keep in sync with CSS transition
		window.setTimeout(() => {
			this.overlay.classList.add('is-hidden');
			if (this.content) {
				this.content.classList.remove('is-hidden-by-overlay');
			}
		}, duration);
	}
}

(function init() {
	// Auto-instantiate if decorator system isn't used via loadComponents
	const nodes = document.querySelectorAll<HTMLElement>('.js-partner-overlay');
	nodes.forEach((el) => new PartnerOverlayComponent(el));
})();
